var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.721,
    height: 36.893,
    viewBox: "0 0 37.721 36.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6367",
    "data-name": "Group 6367",
    transform: "translate(-351.586 -372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7166",
    "data-name": "Path 7166",
    d: "M15,8h.018",
    transform: "translate(360.037 374.182)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7167",
    "data-name": "Path 7167",
    d: "M20.446,36.056H8.509A5.509,5.509,0,0,1,3,30.547V8.509A5.509,5.509,0,0,1,8.509,3H30.547a5.509,5.509,0,0,1,5.509,5.509V20.446",
    transform: "translate(350 370)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7168",
    "data-name": "Path 7168",
    d: "M3,20.742l9.182-9.182a3.7,3.7,0,0,1,5.509,0l6.428,6.428",
    transform: "translate(350 376.131)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7169",
    "data-name": "Path 7169",
    d: "M14,15.4l1.836-1.836a3.674,3.674,0,0,1,4.066-.966",
    transform: "translate(359.201 377.804)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7170",
    "data-name": "Path 7170",
    d: "M19,27.019V16",
    transform: "translate(363.383 380.874)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7171",
    "data-name": "Path 7171",
    d: "M27.019,21.509,21.509,16,16,21.509",
    transform: "translate(360.874 380.874)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUpload);
export default __webpack_public_path__ + "static/media/logo-upload.eb7f5ae9.svg";
export { ForwardRef as ReactComponent };